import { render, staticRenderFns } from "./IndexTableFilterBool.vue?vue&type=template&id=b5cf1fb4"
import script from "./IndexTableFilterBool.vue?vue&type=script&lang=js"
export * from "./IndexTableFilterBool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports